/**
 * Einheitliche Anzeige für App-Shell / Topbar: Label, Avatar-URL, Initialen.
 * Keine Rollenlogik — nur Supabase-Session user / identities / user_metadata.
 */

function __asStr(v) {
  return String(v ?? "").trim();
}

/**
 * @param {string} label
 * @param {Record<string, unknown>} md user_metadata
 * @returns {string} 0–2 Zeichen für Initialen-Badge
 */
function deriveAvatarInitials(label, md) {
  const meta = md && typeof md === "object" ? md : {};
  const fn = __asStr(meta.first_name || meta.given_name);
  const ln = __asStr(meta.last_name || meta.family_name);
  if (fn && ln) {
    return `${fn.charAt(0)}${ln.charAt(0)}`.toUpperCase();
  }
  if (fn.length >= 2) {
    return fn.slice(0, 2).toUpperCase();
  }
  if (fn.length === 1) {
    return fn.toUpperCase();
  }

  const parts = __asStr(label)
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  }
  const single = parts[0] || "";
  if (single.length >= 2) {
    return single.slice(0, 2).toUpperCase();
  }
  const local = __asStr(label).split("@")[0];
  if (local.length >= 2) {
    return local.slice(0, 2).toUpperCase();
  }
  if (local.length === 1) {
    return local.toUpperCase();
  }
  return "";
}

/**
 * @param {object|null|undefined} session
 * @returns {{ label: string, avatarUrl: string, initials: string }}
 */
export function resolveShellAuthIdentity(session) {
  const u = session?.user;
  if (!u) {
    return { label: "", avatarUrl: "", initials: "" };
  }

  const md = u.user_metadata && typeof u.user_metadata === "object" ? u.user_metadata : {};
  const identities = Array.isArray(u.identities) ? u.identities : [];
  const id0 = identities[0]?.identity_data && typeof identities[0].identity_data === "object" ? identities[0].identity_data : {};

  const avatarUrl = __asStr(md.avatar_url || md.picture || "");

  let label = __asStr(
    u.email ||
      u.phone ||
      md.full_name ||
      md.name ||
      md.preferred_username ||
      md.user_name ||
      id0.email ||
      id0.phone ||
      id0.name ||
      ""
  );

  if (!label && __asStr(id0.sub)) {
    label = __asStr(id0.sub);
  }

  if (!label && __asStr(u.id)) {
    label = __asStr(u.id).slice(0, 12);
  }

  const initials = deriveAvatarInitials(label, md);

  return { label, avatarUrl, initials };
}
